.header {
  margin-bottom: var(--space-7);
}

.headerRow {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-6);
}

.title {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: var(--text-2xl);
  font-weight: 620;
  letter-spacing: -0.035em;
  line-height: 1.05;
}

/* The section's line sign, as in the sidebar but larger. */
.badge {
  display: inline-grid;
  place-items: center;
  min-width: 42px;
  height: 32px;
  padding: 0 6px;
  border-radius: 7px;
  background: var(--tone);
  color: var(--tone-on);
  font-family: var(--font-mono);
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0;
}

.meta {
  margin-top: var(--space-3);
  color: var(--ink-2);
  font-size: var(--text-md);
}

.actions {
  display: flex;
  gap: var(--space-2);
}

/* The line itself: drawn from left to right when the page opens. */
.band {
  display: block;
  height: 4px;
  margin-top: var(--space-6);
  border-radius: 2px;
  background: var(--tone);
  transform-origin: left center;
  animation: draw 900ms var(--ease-out) 120ms both;
}

@keyframes draw {
  from {
    transform: scaleX(0);
  }
}

.section {
  animation: rise var(--duration-slow) var(--ease-out) both;
}

.section + .section {
  margin-top: var(--space-8);
  animation-delay: 90ms;
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}

.sectionHead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-4);
  padding-bottom: var(--space-2);
  border-bottom: 1px solid var(--line);
}

.sectionTitle {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--text-2xs);
  font-weight: 650;
  letter-spacing: var(--tracking-label);
  text-transform: uppercase;
  color: var(--tone-ink);
}

.sectionTitle::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background: var(--tone);
}

.empty {
  padding: var(--space-6) 0;
  color: var(--ink-2);
}

.emptyHint {
  margin-top: var(--space-1);
  color: var(--ink-3);
  font-size: var(--text-sm);
}

.kbd {
  display: inline-block;
  min-width: 20px;
  padding: 1px 5px;
  border: 1px solid var(--line-strong);
  border-bottom-width: 2px;
  border-radius: var(--radius-sm);
  font-family: var(--font-mono);
  font-size: 11px;
  line-height: 1.4;
  text-align: center;
  color: var(--ink-2);
}

/* On a phone the actions go under the title, and there is no keyboard to hint at. */
@media (max-width: 760px) {
  .header {
    margin-bottom: var(--space-5);
  }

  .headerRow {
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-3);
  }

  .actions {
    flex-wrap: wrap;
  }

  .band {
    margin-top: var(--space-4);
  }

  .kbd {
    display: none;
  }

  .section + .section {
    margin-top: var(--space-7);
  }

  .sectionHead {
    flex-wrap: wrap;
    gap: var(--space-2);
  }
}
